import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import userStore from "../../zustand/userStore";
import {
  createUser,
  fetchOrgUsersById,
} from "../../pages/user/redux/userThunk";
import { createStudent, fetchOrgStudents } from "./redux/quizSlice";
import { studentClasses } from "../../configs/WebService";
import axios from "axios";

const CreateStudent = ({ onClose }) => {
  const dispatch = useDispatch();
  const userData = userStore((state) => state.user);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    studentClass: "",
    rollNumber: "",
    dob: "",
    contactNumber: "",
    registrationDate: "",
  });

  const [classes, setClasses] = useState([]);

  useEffect(() => {
    axios
      .get(studentClasses)
      .then((res) => {
        if (res.data.success) {
          setClasses(res.data.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching classes:", err);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const body = {
      username: formData.name,
      email: formData.email,
      password: formData.password,
      role_id: 4,
      created_by: userData.id,
      school_name: userData.school_name,
      contact_number: formData.contactNumber,
      dob: formData.dob,
      studentClass: formData.studentClass,
      section: "",
      rollNumber: formData.rollNumber,
      registrationDate: formData.registrationDate,
      address: userData.address,
      school_type: "Primary",
      db_name: userData.db_name,
      port: userData.port,
      account_type: userData.account_type,
      parent_id: userData.admin_id || "",
    };

    try {
      await dispatch(createStudent(body)).unwrap();
      const schoolId =
        userData?.db_name === "ST_ANTHONY_db" ? userData?.admin_id : null;
      dispatch(fetchOrgStudents(schoolId));
      alert("✅ Student created successfully!");
      onClose();
    } catch (err) {
      alert("❌ Failed to create student: " + err.message);
    }
  };

  const fieldWrapperStyle = {
    display: "flex",
    flexDirection: "column",
    width: "300px",
    margin: "10px",
  };

  const inputStyle = {
    height: "40px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    paddingLeft: "10px",
  };

  const selectStyle = {
    height: "40px",
    borderRadius: "8px",
    border: "1px solid #ccc",
    paddingLeft: "10px",
  };

  return (
    <div
      style={{
        padding: "20px",
        borderRadius: "15px",
        border: "1px solid #e0e0e0",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        marginTop: "10px",
      }}
    >
      <form onSubmit={handleSubmit}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "flex-start",
          }}
        >
          {/* Name */}
          <div style={fieldWrapperStyle}>
            <label style={{ fontWeight: "600" }}>Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter student name"
              required
              style={inputStyle}
            />
          </div>

          {/* Email */}
          <div style={fieldWrapperStyle}>
            <label style={{ fontWeight: "600" }}>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter email"
              required
              style={inputStyle}
            />
          </div>

          {/* Password */}
          <div style={fieldWrapperStyle}>
            <label style={{ fontWeight: "600" }}>Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Enter password"
              required
              style={inputStyle}
            />
          </div>

          {/* Class */}
          <div style={fieldWrapperStyle}>
            <label style={{ fontWeight: "600" }}>Class</label>
            <select
              name="studentClass"
              value={formData.studentClass}
              onChange={handleChange}
              required
              style={selectStyle}
            >
              <option value="">Select Class</option>
              {classes.map((cls) => (
                <option key={cls.class_id} value={cls.class_id}>
                  {cls.class_name}
                </option>
              ))}
            </select>
          </div>

          {/* Roll Number */}
          <div style={fieldWrapperStyle}>
            <label style={{ fontWeight: "600" }}>Roll Number</label>
            <input
              type="text"
              name="rollNumber"
              value={formData.rollNumber}
              onChange={handleChange}
              placeholder="Enter roll number"
              required
              style={inputStyle}
            />
          </div>

          {/* Date of Birth */}
          <div style={fieldWrapperStyle}>
            <label style={{ fontWeight: "600" }}>Date of Birth</label>
            <input
              type="date"
              name="dob"
              value={formData.dob}
              onChange={handleChange}
              required
              style={inputStyle}
            />
          </div>

          {/* Contact Number */}
          <div style={fieldWrapperStyle}>
            <label style={{ fontWeight: "600" }}>Contact Number</label>
            <input
              type="tel"
              name="contactNumber"
              value={formData.contactNumber}
              onChange={handleChange}
              placeholder="Enter contact number"
              required
              style={inputStyle}
            />
          </div>

          {/* Registration Date */}
          <div style={fieldWrapperStyle}>
            <label style={{ fontWeight: "600" }}>Date of Registration</label>
            <input
              type="date"
              name="registrationDate"
              value={formData.registrationDate}
              onChange={handleChange}
              required
              style={inputStyle}
            />
          </div>
        </div>

        {/* Submit Button */}
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <button
            type="submit"
            style={{
              backgroundColor: "green",
              color: "white",
              padding: "10px 40px",
              border: "none",
              borderRadius: "10px",
              height: "45px",
              fontWeight: "500",
              cursor: "pointer",
            }}
          >
            Create Student
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateStudent;
